import React from 'react'
import PropTypes from 'prop-types'
import { ContainedButton, HeaderThree } from 'secondstep-components'
import { toKebabCase } from 'utils/stringHelpers'

import {
  GradeCourseLinks,
  GradeSection,
  PreviewCourseLinksList,
} from './component.styles'

const GRADE_SECTIONS = {
  Elementary: ['k', '1', '2', '3', '4', '5'],
  'Middle School': ['6', '7', '8'],
  'High School': ['9', '10', '11', '12'],
}

const courseLinkShape = PropTypes.shape({
  courseName: PropTypes.string,
  entryId: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
})

const getCourseKey = course => course.slug || course.entryId || course.title

const getCourseLinkDataTestId = course =>
  `course-link-${toKebabCase(getCourseKey(course))}`

const getGradeKey = course => {
  const slugGrade = course.slug?.split('-')[1]
  if (slugGrade) return slugGrade

  if (course.courseName) return course.courseName

  return course.title
    ?.replace(/^grade\s+/i, '')
    .replace(/^kindergarten$/i, 'k')
    .toLowerCase()
}

const CourseLinkItem = ({ course, getOnClick, getTitle }) => (
  <li>
    <ContainedButton
      dataTestId={getCourseLinkDataTestId(course)}
      onClick={getOnClick(course)}
    >
      {getTitle(course)}
    </ContainedButton>
  </li>
)

CourseLinkItem.propTypes = {
  course: courseLinkShape.isRequired,
  getOnClick: PropTypes.func.isRequired,
  getTitle: PropTypes.func.isRequired,
}

export const PreviewCourseList = ({
  courseLinks,
  getOnClick,
  getTitle,
  isDigitalWellBeing = false,
  tier,
}) => {
  if (!courseLinks?.length) return null

  return (
    <PreviewCourseLinksList
      $isDigitalWellBeing={isDigitalWellBeing}
      $tier={tier}
      data-testid={
        isDigitalWellBeing ? 'digital-well-being-course-links' : undefined
      }
    >
      {isDigitalWellBeing &&
        Object.entries(GRADE_SECTIONS).map(([grade, courses]) => {
          const gradeCourseLinks = courseLinks.filter(course =>
            courses.includes(getGradeKey(course)),
          )

          return (
            <GradeSection key={grade}>
              <HeaderThree dataTestId={`header-grade-${toKebabCase(grade)}`}>
                {grade}
              </HeaderThree>
              <GradeCourseLinks>
                {gradeCourseLinks.map(course => (
                  <CourseLinkItem
                    course={course}
                    getOnClick={getOnClick}
                    getTitle={getTitle}
                    key={getCourseKey(course)}
                  />
                ))}
              </GradeCourseLinks>
            </GradeSection>
          )
        })}
      {!isDigitalWellBeing &&
        courseLinks.map(course => (
          <CourseLinkItem
            course={course}
            getOnClick={getOnClick}
            getTitle={getTitle}
            key={getCourseKey(course)}
          />
        ))}
    </PreviewCourseLinksList>
  )
}

PreviewCourseList.propTypes = {
  courseLinks: PropTypes.arrayOf(courseLinkShape),
  getOnClick: PropTypes.func.isRequired,
  getTitle: PropTypes.func.isRequired,
  isDigitalWellBeing: PropTypes.bool,
  tier: PropTypes.number,
}
